import { routerStyxie } from '@/router/styxieBridge'
import { useGeogridsCommonStore } from '@/stores/geogrids/common'

// Geogrids is client-side routed: every action boots the shared router shell.
// The payload hydrates the common store (it picks what it needs); per-page
// params (configId, geogrid_id) come from the URL via the route definitions.
Styxie.Initializers.ScheduledGeogrids = routerStyxie({
  actions: ['index', 'new', 'edit', 'show'],
  hydrate: (props, pinia) => useGeogridsCommonStore(pinia).initialize(props)
})
